import {onWindowMessage, $qsAll} from '../../../@shared/ts/dom';
import {type InitMessage, type PageLanguageChangeMessage} from '../../../@type/window-messages';
import {type IDictionary} from '../../../@type/dictionary';
import {Environment, updateLanguage, updateTranslatedModalTerms} from '../reducers/environmentReducer';
import {store} from '../store';
import {getLocaleText} from '../util/translation';
import {Feature} from '../reducers/environmentReducer';
import {FeatureFlag} from '../../../@type/features';

let TRANSLATED_MODAL_TERMS_ALL_LANGUAGES: Record<string, IDictionary>;

export function initLanguage(message: InitMessage) {
	initLanguageEvents();

	const language = message.phpData.language === 'detect-from-page' ? message.pageLanguage : message.phpData.language;

	store.dispatch(updateLanguage(language));

	const translatedModalTermsAllLanguages = Feature.metadata<Record<string, IDictionary>>(FeatureFlag.TRANSLATED_MODAL_TERMS, 'all_languages');
	if (translatedModalTermsAllLanguages) {
		TRANSLATED_MODAL_TERMS_ALL_LANGUAGES = translatedModalTermsAllLanguages;

		store.dispatch(updateTranslatedModalTerms(TRANSLATED_MODAL_TERMS_ALL_LANGUAGES?.[language] ?? {}));
	} else {
		const translatedModalTerms = Feature.metadata<IDictionary>(FeatureFlag.TRANSLATED_MODAL_TERMS, 'selected_language');
		store.dispatch(updateTranslatedModalTerms(translatedModalTerms ?? {}));
	}
}

function initLanguageEvents() {
	onWindowMessage<PageLanguageChangeMessage>('pageLanguageChange', message => {
		store.dispatch(updateLanguage(message.language));

		store.dispatch(updateTranslatedModalTerms(TRANSLATED_MODAL_TERMS_ALL_LANGUAGES?.[message.language] ?? {}));
	});

	store.subscribe(() => {
		renderLocaleText();
	});
}

function renderLocaleText() {
	for (const $element of $qsAll('[data-i18n]')) {
		if ($element.nodeName === 'INPUT' && ($element as HTMLInputElement).type === 'submit') {
			($element as HTMLInputElement).value = getLocaleText($element?.dataset['i18n'] ?? '');
		} else if ($element.nodeName === 'INPUT') {
			($element as HTMLInputElement).placeholder = getLocaleText($element?.dataset?.['i18n'] ?? '');
		} else if ($element?.dataset['i18n'] === 'Back' && Environment.language() !== 'en-US') {
			($element.textContent) = getLocaleText('Return');
		} else {
			$element.textContent = getLocaleText($element?.dataset['i18n'] ?? '');
		}
	}

	// A Romanian merchant says that even after changing Chrome's language, the
	// required input validity message shows up in English. The device should take
	// care of this, so I'm not sure what's going on over at the merchant's end.
	// This is the most convenient way to fix the issue for now.
	if (Environment.language() === 'ro-RO') {
		setCustomValidityMessage();
	}
}

function setCustomValidityMessage(): void {
	// Only used for one specific merchant who insists that his device doesn't
	// do the translation
	for (const $input of $qsAll<HTMLInputElement>('form input')) {
		$input.addEventListener('invalid', () => {
			$input.setCustomValidity('Te rugăm sa completezi acest câmp.');
		});

		$input.addEventListener('input', () => {
			$input.setCustomValidity('');
		});
	}
}
